import { AfterViewInit, Component, ElementRef, EventEmitter, Input, Output, TemplateRef, ViewChild } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { NgbModal, NgbModalRef } from '@ng-bootstrap/ng-bootstrap';
import { ToastrService } from 'ngx-toastr';
import { SettlementsService } from 'src/app/services/settlements.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-modal-add-floor',
  template: `
    <ng-template #modalAddFloor let-modal>
      <div class="modal-header">
        <h5 class="modal-title">{{ mode === 'creation' ? 'Agregar piso' : 'Editar Piso'}}</h5>
        <button type="button" (click)="dismiss()" data-dismiss="modal" aria-label="Close" class="btn btn-link text-dark">
          <fa-icon [icon]="icons.faTimes"></fa-icon>
        </button>
      </div>
      <div class="modal-body p-4">
      <form [formGroup]="floorForm" (ngSubmit)="onSubmit()">
          <div class="form-group required">
            <label for="name" class="form-label">Piso</label>
            <input formControlName="name" class="form-control" placeholder="Nombre del piso">
            <div *ngIf="ffc['name']?.touched && ffc['name']?.invalid">
            <div *ngIf="ffc['name'].errors?.['required']" class="text-danger text-sm">El nombre del piso es requerido.</div>
          </div>
          </div>
          <div class="form-group text-end mt-3">
            <button type="submit" class="btn btn-outline-success">Guardar</button>
          </div>
        </form>
      </div>
    </ng-template>
  `,
  styleUrls: []
})
export class ModalAddFloorComponent implements AfterViewInit {
  @Input() building: any;
  @Output() updateDismiss: EventEmitter<any> = new EventEmitter<any>();
  @ViewChild('modalAddFloor') modalAddFloor!: TemplateRef<any>;
  public mode = 'creation';
  
  private modalRef: NgbModalRef | undefined;

  floorForm: FormGroup = new FormGroup({});

  constructor(
    private store: SettlementsService,
    private toastr: ToastrService,
    public icons: IconsService,
    private fb: FormBuilder,
    private modalService: NgbModal
  ) { }

  ngAfterViewInit(): void {
    this.initForm();
  }

  initForm(): void {
    this.floorForm = this.fb.group({
      id: [],
      name: ['', Validators.required],
      building_id: []
    });
  }

  get ffc() {
    return this.floorForm.controls;
  }

  onSubmit() {
    if (this.floorForm.invalid) {
      this.floorForm.markAllAsTouched();
      this.toastr.error('Formulario inválido.', 'Error');
      return;
    }

    console.log('floorForm => ', this.building);

    this.floorForm.patchValue({ building_id: this.building });

    if (!this.floorForm.value.id) {
      this.store.createFloor(this.floorForm.value).subscribe({
        next: (data: any) =>  {
          this.toastr.success('Piso creado con correctamente.', '¡Éxito!');
          this.dismiss();
        },
        error: (error: any) => {
          console.log('error => ', error);
          this.toastr.error('Piso no pudo ser creado.', 'Error');
        }
      });
    } else {
      this.store.updateFloor(this.floorForm.value.id, this.floorForm.value).subscribe({
        next: (data: any) =>  {
          this.toastr.success('Piso creado con correctamente.', '¡Éxito!');
          this.dismiss();
        },
        error: (error: any) => {
          console.log('error => ', error);
          this.toastr.error('Piso no pudo ser creado.', 'Error');
        }
      });
    }
  }

  openModal(modalContent: TemplateRef<any>, mode = 'creation') {
    this.mode = mode;
    this.modalRef = this.modalService.open(modalContent);
  }

  dismiss() {
    if (this.modalRef) {
      this.updateDismiss.emit();
      this.modalRef.dismiss();
    }
  }
}
